import Data from 'data';
import { AuraFlags, skillAuraStats, skillAuraStatsLazy, skillFormula, skillPassiveStats, skillPassiveStatsLazy } from 'logic/skills/calc';
import { DamageCalculator, missileDamage } from '../damage';

const functions = {};

// Poison Explosion

functions[63] = {
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target);
  },
};

// Sacrifice

functions[64] = {
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    calc.nocrit = true;
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'clc1', stats, level));
    calc.convert(skill.etype, skillFormula(skill, 'clc4', stats, level));
    calc.srcdam(skill.srcdam);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    calc.resultflags = skill.resultflags;
    return calc.calculate(target);
  },
};

// Friendly auras

functions[65] = {
  showActive: id => !!(Data.skills[id].aurastate || Data.skills[id].auratargetstate),
  group: () => 'aura',
  active: unit => ({
    active: unit === 'player' ? false : true,
  }),
  aura(id, stats, level, active, itemAura) {
    const skill = Data.skills[id];
    if (!itemAura && !(active || this.active(stats.unit)).active) {
      if (skill.passivestate) {
        return {
          level,
          state: skill.passivestate,
          stats: () => skillPassiveStats(skill, stats, level),
          priority: 10,
        };
      } else {
        return null;
      }
    }
    const result = {
      level,
      filter: skill.aurafilter,
      state: (skill.passivestate === 67 ? 67 : skill.aurastate), // quick fix for penetrate vs blessed aim
      stats: () => skillAuraStats(skill, stats, level),
      targetState: (skill.passivestate === 67 ? 67 : skill.auratargetstate),
      targetStats: () => skillAuraStats(skill, stats, level),
    };
    if (!skill.passivestate && stats.unit === 'player') {
      result.stats = () => {
        const res = {...skillAuraStatsLazy(skill, stats, level), ...skillPassiveStatsLazy(skill, stats, level)};
        for (const id in res) {
          res[id] = res[id]();
        }
        return res;
      };
    }
    return result;
  },
};

// Hostile auras

functions[66] = {
  showActive: id => !!(Data.skills[id].aurastate || Data.skills[id].auratargetstate),
  group: () => 'aura',
  active: unit => ({
    active: unit === 'player' ? false : true,
  }),
  aura(id, stats, level, active, itemAura) {
    if (!itemAura && !(active || this.active(stats.unit)).active) return;
    const skill = Data.skills[id];
    return {
      level,
      filter: skill.aurafilter,
      state: skill.aurastate,
      stats: () => skillPassiveStats(skill, stats, level),
      targetState: skill.auratargetstate,
      targetStats: () => skillAuraStats(skill, stats, level),
    };
  },
  damage(skill, stats, weapon, level, target) {
    if (!(target.aura_include & skill.aurafilter)) return;
    if (target.aura_exclude & skill.aurafilter) return;
    const calc = new DamageCalculator(stats, weapon, false, false);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.srcdam(skill.srcdam);
    if (calc.empty()) return;
    return calc.calculate(target);
  },
};

// Charge

functions[67] = {
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'clc1', stats, level));
    calc.convert(skill.etype, skillFormula(skill, 'clc4', stats, level));
    calc.srcdam(skill.srcdam);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    return calc.calculate(target);
  },
  animation() {},
  dps() {},
};

// Buff/debuff shouts

functions[68] = {
  showBuff(id, stats, level) {
    const skill = Data.skills[id];
    return (skill.aurastate || skill.auratargetstate);
  },
  buff(id, stats, level) {
    const skill = Data.skills[id];
    return {
      level,
      filter: AuraFlags.FindPlayers | AuraFlags.FindMonsters | AuraFlags.NotInsideTown2 | (skill.aurafilter ?
        AuraFlags.OnlyAttackable | AuraFlags.NotInsideTown | AuraFlags.UseLineOfSight | AuraFlags.OnlySelectable | AuraFlags.IgnoreAllies :
        AuraFlags.TargetAllies
      ),
      state: skill.aurastate,
      stats: () => skillAuraStats(skill, stats, level),
      targetState: skill.auratargetstate,
      targetStats: () => skillAuraStats(skill, stats, level),
    };
  },
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target);
  },
};

export default functions;
